import { EventBus, EnumEventBus } from "../EventBus";
import { INITIAL_TRIANGLE_RADIANS, CIRCLE_RADIUS } from "../../types/Config";
import { Coord } from "../../../../../src/types/Interface";
import { getTangentCoords } from "../../helpers/getTangentCoords";
import { generateRandomlyRadians } from "./helpers/helperPointer";
import BasePointManager from "../../../../../src/managers/BasePointManager";


export default class PointManager extends BasePointManager {
  private EventBus = EventBus;
  tangent: Coord[] = [];
  sltdTPIndex = 0 // selected Tangent Point Index
  constructor(cCoord: Coord) {
    super(cCoord, CIRCLE_RADIUS, INITIAL_TRIANGLE_RADIANS)

    this.setCoord();
    this.draw();

    this.EventBus.on(EnumEventBus.genRndmTriangle, () => this.generateRandomShape())
    this.EventBus.on(EnumEventBus.moveTangentPoint, (v: number) => this.moveTangentPoint(v));
    this.EventBus.on(EnumEventBus.moveAllPoints, (v: number) => this.moveAllPoints(v));
    this.EventBus.on(EnumEventBus.setRefPoints, () => this.pointRefRadians = [...this.pointRadians]);
    this.EventBus.on(EnumEventBus.setSltdTPIndex, (index: number) => {
      this.sltdTPIndex = index;
      this.setCoord();
    })
  }
  getTangentCoords = () => this.tangent;
  getSltdTPointIndex = () => this.sltdTPIndex;
  generateRandomShape = () => generateRandomlyRadians(this);
  moveTangentPoint(v: number) {
    const tangentPoint = this.getRedPoints()[this.sltdTPIndex];
    const radian = this.pointRefRadians[this.sltdTPIndex] + v / 100 * (Math.PI / 3);
    this.setRadian([{ pTag: tangentPoint.tag, radian }], true)
  }

  moveAllPoints(v: number) {
    const pointInfoArr = [...this.getRedPoints()].map((p, pI) => {
      const radian = this.pointRefRadians[pI] + v / 100 * (Math.PI / 3);
      return { pTag: p.tag, radian };
    })
    this.setRadian(pointInfoArr, true);
  }
  setCoord() {
    const tPointCoord = this.getRedPointsCoord()[this.sltdTPIndex];
    this.tangent = getTangentCoords(this.cCoord, tPointCoord, 300);
    this._setCoord();
  }
}